import React from 'react';
import StaticPage from '../components/StaticPage/StaticPage';

const PrivacyPolicy = () => {
  return (
    <StaticPage title="Política de Privacidad">
        <h1>Política de Privacidad - CoffeePassport</h1>
        <p><strong>Última actualización:</strong> 24 de octubre de 2023</p>

        <p>Bienvenido/a a <strong>CoffeePassport</strong> ("nosotros", "nuestro/a" o "la aplicación"). Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos la información que obtenemos a través de nuestra aplicación. Al utilizar <strong>CoffeePassport</strong>, aceptas las prácticas descritas en esta política.</p>

        <h2>1. Información que recopilamos</h2>
        <p>Recopilamos información de dos maneras principales: <strong>información proporcionada por el usuario</strong> e <strong>información recopilada automáticamente</strong>.</p>

        <h3>a. Información proporcionada por el usuario</h3>
        <ul>
            <li><strong>Datos de inicio de sesión</strong>: Recopilamos información cuando inicias sesión en nuestra aplicación mediante tu cuenta de Instagram o Facebook. Esto incluye:
                <ul>
                    <li>Nombre de usuario</li>
                    <li>Dirección de correo electrónico</li>
                    <li>ID de usuario único</li>
                    <li>Token de acceso</li>
                </ul>
            </li>
            <li><strong>Contenido compartido</strong>: Si decides compartir contenido (por ejemplo, historias o publicaciones), recopilaremos los datos necesarios para realizar esta acción.</li>
        </ul>

        <h3>b. Información recopilada automáticamente</h3>
        <ul>
            <li><strong>Datos de uso</strong>: Recopilamos información sobre cómo interactúas con nuestra aplicación, como:
                <ul>
                    <li>Dirección IP</li>
                    <li>Tipo de navegador y dispositivo</li>
                    <li>Fecha y hora de acceso</li>
                    <li>Páginas visitadas</li>
                </ul>
            </li>
            <li><strong>Cookies y tecnologías similares</strong>: Utilizamos cookies y otras tecnologías para mejorar tu experiencia y analizar el uso de la aplicación.</li>
        </ul>

        <h2>2. Cómo utilizamos la información</h2>
        <p>Utilizamos la información recopilada para los siguientes propósitos:</p>
        <ul>
            <li><strong>Proporcionar y mejorar nuestros servicios</strong>: Para permitirte iniciar sesión, compartir contenido y acceder a las funciones de nuestra aplicación.</li>
            <li><strong>Personalización</strong>: Para adaptar la experiencia de usuario según tus preferencias.</li>
            <li><strong>Cumplimiento legal</strong>: Para cumplir con nuestras obligaciones legales y resolver disputas.</li>
            <li><strong>Análisis y mejora</strong>: Para analizar el uso de la aplicación y mejorar su rendimiento y funcionalidad.</li>
        </ul>

        <h2>3. Compartir información con terceros</h2>
        <p>No vendemos ni alquilamos tu información personal a terceros. Sin embargo, podemos compartir tu información en los siguientes casos:</p>
        <ul>
            <li><strong>Proveedores de servicios</strong>: Podemos compartir información con proveedores externos que nos ayudan a operar nuestra aplicación (por ejemplo, hosting, análisis de datos).</li>
            <li><strong>Redes sociales</strong>: Compartimos información con Instagram/Facebook para habilitar las funciones de la aplicación (por ejemplo, publicar historias).</li>
            <li><strong>Cumplimiento legal</strong>: Podemos divulgar información si es necesario para cumplir con una ley, regulación o proceso legal.</li>
        </ul>

        <h2>4. Seguridad de la información</h2>
        <p>Nos comprometemos a proteger la seguridad de tu información. Implementamos medidas técnicas y organizativas adecuadas para prevenir el acceso no autorizado, la alteración, divulgación o destrucción de datos. Estas medidas incluyen:</p>
        <ul>
            <li>Cifrado de datos en tránsito y en reposo</li>
            <li>Control de acceso limitado a la información</li>
            <li>Monitoreo regular de sistemas</li>
        </ul>
        <p>Sin embargo, ninguna transmisión de datos por Internet o sistema de almacenamiento es completamente segura. No podemos garantizar la seguridad absoluta de la información.</p>

        <h2>5. Derechos del usuario</h2>
        <p>Dependiendo de tu ubicación, podrías tener ciertos derechos sobre tus datos personales, como:</p>
        <ul>
            <li><strong>Acceso</strong>: Solicitar una copia de los datos que tenemos sobre ti.</li>
            <li><strong>Rectificación</strong>: Corregir información inexacta o incompleta.</li>
            <li><strong>Eliminación</strong>: Solicitar la eliminación de tus datos.</li>
            <li><strong>Oposición</strong>: Oponerte al procesamiento de tus datos.</li>
            <li><strong>Portabilidad</strong>: Recibir tus datos en un formato estructurado y comúnmente utilizado.</li>
        </ul>
        <p>Para ejercer estos derechos, contáctanos a través de <a href="mailto:deibyod@gmail.com">deibyod@gmail.com</a>.</p>

        <h2>6. Cambios en esta Política de Privacidad</h2>
        <p>Podemos actualizar esta Política de Privacidad ocasionalmente. Te notificaremos sobre cambios significativos publicando un aviso en nuestra aplicación o enviándote un correo electrónico. Te recomendamos revisar esta política periódicamente para estar informado/a sobre cómo protegemos tu información.</p>

        <h2>7. Contacto</h2>
        <p>Si tienes preguntas, comentarios o inquietudes sobre esta Política de Privacidad o nuestras prácticas de privacidad, contáctanos a través de:</p>
        <ul>
            <li><strong>Correo electrónico</strong>: <a href="mailto:deibyod@gmail.com">deibyod@gmail.com</a></li>
            <li><strong>Dirección física</strong>: Santiago, Chile</li>
        </ul>

        <h2>8. Consentimiento</h2>
        <p>Al utilizar <strong>CoffeePassport</strong>, aceptas los términos de esta Política de Privacidad. Si no estás de acuerdo con esta política, por favor, no utilices nuestra aplicación.</p>

        <h2>9. Ley aplicable</h2>
        <p>Esta Política de Privacidad se rige por las leyes de Chile. Cualquier disputa relacionada con esta política se resolverá exclusivamente en los tribunales chilenos.</p>

        <h2>Adaptación específica para Meta</h2>
        <p><strong>CoffeePassport</strong> utiliza la API de Instagram/Facebook para permitir a los usuarios compartir contenido en sus cuentas de Instagram. Solo accedemos a los datos necesarios para proporcionar estas funciones y cumplimos estrictamente con las <a href="https://developers.facebook.com/policy/">Políticas de Plataforma de Meta</a>. Los usuarios deben otorgar permiso explícito antes de que accedamos a su información.</p>
    </StaticPage>
  );
};

export default PrivacyPolicy;